// Messages for operator/Dashboard (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.dashboard.head': 'Dashboard — Operator',
  'operator.dashboard.title': 'Operations Overview',
  'operator.dashboard.welcome':
    "Welcome back, {name} — here's what's moving across the network today.",
  'operator.dashboard.intro': "Here's what's moving across the network today.",
  'operator.dashboard.create_shipment': 'Create shipment',
  'operator.dashboard.range.all': 'All',
  'operator.dashboard.range.30d': '30d',
  'operator.dashboard.range.90d': '90d',
  'operator.dashboard.range.365d': '1y',
  'operator.dashboard.kpi.active': 'Active Shipments',
  'operator.dashboard.kpi.quotes': 'Quotes',
  'operator.dashboard.kpi.on_time': 'On-Time Rate',
  'operator.dashboard.kpi.avg_transit': 'Avg Transit',
  'operator.dashboard.delta_suffix': ' vs last wk',
  'operator.dashboard.volume.title': 'Shipment Volume',
  'operator.dashboard.volume.sub': 'shipments booked by mode · last 6 months',
  'operator.dashboard.live': 'Live',
  'operator.dashboard.mode.ocean': 'Ocean',
  'operator.dashboard.mode.air': 'Air',
  'operator.dashboard.mode.truck': 'Truck',
  'operator.dashboard.mode.rail': 'Rail',
  'operator.dashboard.status_mix.title': 'Status Mix',
  'operator.dashboard.status_mix.sub': '{count} shipments',
  'operator.dashboard.status_mix.empty': 'No shipments yet.',
  'operator.dashboard.needs.title': 'Needs Attention',
  'operator.dashboard.needs.sub': 'exceptions, customs holds & quote requests',
  'operator.dashboard.needs.open': '{count} open',
  'operator.dashboard.needs.empty': 'Nothing needs attention. 🎉',
  'operator.dashboard.needs.eta': 'ETA {eta}',
  'operator.dashboard.needs.request': 'Quote Request',
  'operator.dashboard.needs.requested': 'received {date}',
  'operator.dashboard.needs.visitor': 'Website visitor',
  'operator.dashboard.lanes.title': 'Top Lanes',
  'operator.dashboard.lanes.sub': 'by shipment count',
  'operator.dashboard.lanes.empty': 'No lanes yet.',
}

export const zhTW = {
  'operator.dashboard.head': '儀表板 — 操作端',
  'operator.dashboard.title': '營運總覽',
  'operator.dashboard.welcome': '{name}，歡迎回來 — 以下是今日網路上的最新動態。',
  'operator.dashboard.intro': '以下是今日網路上的最新動態。',
  'operator.dashboard.create_shipment': '建立貨件',
  'operator.dashboard.range.all': '全部',
  'operator.dashboard.range.30d': '30天',
  'operator.dashboard.range.90d': '90天',
  'operator.dashboard.range.365d': '1年',
  'operator.dashboard.kpi.active': '進行中貨件',
  'operator.dashboard.kpi.quotes': '報價',
  'operator.dashboard.kpi.on_time': '準時率',
  'operator.dashboard.kpi.avg_transit': '平均運輸天數',
  'operator.dashboard.delta_suffix': ' 較上週',
  'operator.dashboard.volume.title': '貨件量',
  'operator.dashboard.volume.sub': '依運輸方式預訂的貨件 · 過去 6 個月',
  'operator.dashboard.live': '即時',
  'operator.dashboard.mode.ocean': '海運',
  'operator.dashboard.mode.air': '空運',
  'operator.dashboard.mode.truck': '卡車',
  'operator.dashboard.mode.rail': '鐵路',
  'operator.dashboard.status_mix.title': '狀態分布',
  'operator.dashboard.status_mix.sub': '{count} 件貨件',
  'operator.dashboard.status_mix.empty': '尚無貨件。',
  'operator.dashboard.needs.title': '需要關注',
  'operator.dashboard.needs.sub': '異常、海關扣留與報價請求',
  'operator.dashboard.needs.open': '{count} 件未處理',
  'operator.dashboard.needs.empty': '沒有需要關注的項目。🎉',
  'operator.dashboard.needs.eta': '預計到達 {eta}',
  'operator.dashboard.needs.request': '報價請求',
  'operator.dashboard.needs.requested': '收到於 {date}',
  'operator.dashboard.needs.visitor': '網站訪客',
  'operator.dashboard.lanes.title': '熱門航線',
  'operator.dashboard.lanes.sub': '依貨件數量',
  'operator.dashboard.lanes.empty': '尚無航線。',
}
